import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  constructor() { }

  private _activeSideBarMenu = '';
  public activeSideBarMenu: BehaviorSubject<string> = new BehaviorSubject<string>(this._activeSideBarMenu);
  public showSideBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public showPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private hideHeader$ = new Subject<any>();
  showHeader() {
    this.hideHeader$.next(true);
  }

  hideHeader() {
    this.hideHeader$.next(false);
  }

  getHeaderStatus() : Observable<any> {
    return this.hideHeader$.asObservable();
  }

  showSideMenu() {
    this.showPage.next(false);
    this.showSideBar.next(true);
  }
}
